enum DateType {
    DateTime = 'datetime',
    DateOnly = 'dateonly'
}

export default DateType;